import { motion } from "framer-motion";
import { Rocket, TrendingUp, Megaphone, Filter } from "lucide-react";
import { PROCESS } from "../data/content";

const ICONS = [Rocket, TrendingUp, Megaphone, Filter];

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative border-y border-white/10 bg-[#0d1013] tech-grid">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28">
      <p className="font-mono2 text-xs sm:text-sm tracking-[0.25em] text-[#A3E635] uppercase mb-4">
        // The growth engine
      </p>
      <h2 className="font-heading text-3xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[1.0] mb-4">
        Start. Grow. <span className="text-[#A3E635]">Amplify.</span> Convert.
      </h2>
      <p className="text-base sm:text-lg text-slate-400 max-w-xl leading-relaxed mb-16">
        How we take brands from zero visibility to market domination — one ruthless phase at a time.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {PROCESS.map((p, i) => {
          const Icon = ICONS[i];
          return (
            <motion.div
              key={p.step}
              data-testid={`process-step-${p.phase.toLowerCase()}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.65, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="trace-card group relative rounded-2xl border border-white/10 bg-black/50 backdrop-blur-sm p-8"
            >
              <div className="absolute left-0 top-8 bottom-8 w-[3px] rounded-full bg-gradient-to-b from-[#A3E635] to-transparent opacity-60" />
              <div className="flex items-center gap-4 mb-8">
                <div className="h-12 w-12 rounded-full border border-[#A3E635]/40 flex items-center justify-center glow-lime">
                  <Icon size={20} className="text-[#A3E635]" />
                </div>
                <span className="font-mono2 text-xs tracking-[0.25em] text-slate-500 uppercase">
                  Phase {p.step}
                </span>
              </div>
              <h3 className="font-heading text-2xl font-extrabold uppercase tracking-tight text-[#A3E635] mb-2">
                {p.phase}
              </h3>
              <h4 className="font-heading text-base font-bold tracking-tight mb-3">{p.title}</h4>
              <p className="text-sm text-slate-400 leading-relaxed">{p.description}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
